import { useState, useEffect } from 'react'
import { AssetReference } from '@opallabs/cassini'
import type { SectionOptionProps } from '../../types'

export const isOptionInvalid = (
  option: SectionOptionProps,
  sections: (AssetReference | string | null)[]
): boolean => {
  if (!option) return false
  let invalidFound = false
  const defContent = option.content || ''
  if (option.validation && option.content) {
    const optionContent = option.content as string
    const re = new RegExp(option.validation)
    if (!re.test(optionContent)) {
      invalidFound = true
    }
  }
  if (option.required && !option.content) {
    invalidFound = true
  }
  if (
    option.option === 'section position' &&
    (+defContent > sections.length || +defContent < 1)
  ) {
    invalidFound = true
  }
  return invalidFound
}

export function useValidFormState(
  options: SectionOptionProps[],
  sections: (AssetReference | string | null)[]
): boolean {
  const [isFormValid, setIsFormValid] = useState(true)

  useEffect(() => {
    let invalidFound = false
    if (options) {
      const matchedOptions = options.find((option) =>
        isOptionInvalid(option, sections)
      )
      if (matchedOptions) invalidFound = true
    }
    setIsFormValid(!invalidFound)
  }, [options, sections])

  return isFormValid
}
